import { render, staticRenderFns } from "./company-lists.vue?vue&type=template&id=6bc2946d&scoped=true&"
import script from "./company-lists.vue?vue&type=script&lang=ts&"
export * from "./company-lists.vue?vue&type=script&lang=ts&"
import style0 from "./company-lists.vue?vue&type=style&index=0&id=6bc2946d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2946d",
  null
  
)

export default component.exports